import { ParticleWaveBackground } from '../lib/ParticleWaveBackground';
import ScrollTrigger from 'gsap/ScrollTrigger';

export function initBlockRedCta(parent) {
  if (!parent) return;

  const animationBgEl = parent.querySelector('.block-red-cta__bg');
  if (!animationBgEl) return;

  const animation = new ParticleWaveBackground(animationBgEl, {
    autoStart: false,
    planeWidth: 13.699,
    planeHeight: 5.282,
    widthSegments: 120,
    heightSegments: 70,
    particleSize: 0.035,
    waveHeight: 0.5,
    noiseScale: 2,
    animationSpeed: 6000,
    gradient: [
      { color: '#ffffffff', stop: 0 },
      { color: '#ffffffbb', stop: 100 },
    ],
    rotation: { x: -0.8, y: 0.12, z: -0.1 },
    cameraPosition: [-3.5, -0.58, 3.2],
    cameraRotation: { x: 0, y: 0, z: 0 },
  });

  ScrollTrigger.create({
    trigger: parent,
    start: 'top bottom',
    end: 'bottom top',
    onEnter: () => animation.startAnimation(),
    onLeave: () => animation.stopAnimation(),
    onEnterBack: () => animation.startAnimation(),
    onLeaveBack: () => animation.stopAnimation(),
  });
}

export function initAllBlockRedCtas(selector = '.js-block-red-cta') {
  const blocks = document.querySelectorAll(selector);
  blocks.forEach((block) => initBlockRedCta(block));
}
